"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var _transformers_1 = require("./_transformers");
/**
 * SnakeCase decorator - transrofms keys in your Request to snakeCase
 * @param function
 * @returns function
 ```
  import { snakeCaseRequest } from '../../_decorators';

  @snakeCaseRequest
  getVehicleSummary(vehicleVin: string): Promise<Component[]> {

  ```
 */
function snakeCaseRequest(target, propertyName, propertyDesciptor) {
    var method = propertyDesciptor.value;
    propertyDesciptor.value = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var params = args.map(function (param) {
            return lodash_1.isObject(param) ? _transformers_1.snakeCaseKeys(param, propertyName) : param;
        });
        return method.apply(target, params);
    };
    return propertyDesciptor;
}
exports.snakeCaseRequest = snakeCaseRequest;
